import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
} from "@mui/material";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

const ConfirmDialog: FC<{
  processing: boolean;
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title?: string;
  content?: string;
}> = ({ open, onCancel, onConfirm, title, content, processing }) => {
  const { t } = useTranslation();

  const handleClose = (_: Event, reason: string) => {
    if (processing && reason && reason === "backdropClick") {
      return;
    }
    onCancel();
  };

  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="xs">
      <DialogTitle>{title || t("confirmDialog.title")}</DialogTitle>
      {content && <DialogContent>{content}</DialogContent>}

      <DialogActions sx={{ padding: "16px" }}>
        <Button onClick={onCancel} disabled={processing}>
          {t("confirmDialog.cancelButton")}
        </Button>
        <Button
          onClick={onConfirm}
          autoFocus
          variant="outlined"
          color="error"
          disabled={processing}
        >
          {t("confirmDialog.confirmButton")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
